export class UserAddDays {
  id: number
  addDays: number

  constructor(id: number, addDays: number) {
    this.id = id
    this.addDays = addDays
  }
}
